import ApiService from '@/services/ApiService'

export default {
  store: null,
  checkParams: function(router, store) {
    this.store = store
    const that = this

    return function(to, from, next) {
      if (to.query._fs !== undefined) {
        that.setFairSeriesForUser(
          to.query._fs,
          store.getters['oidcUser']['sub']
        )
        delete to.query._fs
        router.push(to)
      } else {
        next()
      }
    }
  },
  setFairSeriesForUser(fairSeriesID, userID) {
    ApiService.getUser(userID).then(response => {
      if (response.data.length === 0) {
        ApiService.createUser({ id: userID, preferredFairSeries: fairSeriesID })
      } else if (response.data[0].preferredFairSeries !== fairSeriesID) {
        response.data[0].preferredFairSeries = fairSeriesID
        ApiService.updateUser(response.data[0])
      }
    })
  }
}
